import { CookieValues } from '@bit-by-bit-software/types';
import { useCookies } from 'react-cookie';
import { Navigate } from 'react-router-dom';

interface GuardedRouteProps {
  children: React.ReactNode;
  authorizationTypes?: ('admin' | 'customer')[];
}

const GuardedRoute: React.FC<GuardedRouteProps> = ({ children, authorizationTypes }) => {
  const [cookies] = useCookies<'token', CookieValues>(['token']);

  if (!cookies.token || !cookies.user?.authorization) {
    return <Navigate to="/login" replace />;
  }

  if (authorizationTypes && !authorizationTypes.includes(cookies.user.authorization.type)) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default GuardedRoute;
